import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  shopCategories: [],
  shopTypes: [],
  shopLocations: [],
  productCategories: [],
  userList:[],
  userPageInfo:{},
  storeAccounts: [],
  checkedList: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
